var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { GET_ADDRESS_BOOK, GetAddressBookAction, GetAddressBookFailureAction, GetAddressBookSuccessAction, SET_ADDRESS_BOOK_PARAMS } from './address-book.actions';
import { AddressBookService } from './address-book.service';
var AddressBookEffects = /** @class */ (function () {
    function AddressBookEffects(actions$, addressBookService) {
        var _this = this;
        this.actions$ = actions$;
        this.addressBookService = addressBookService;
        this.getContacts$ = this.actions$.pipe(ofType(GET_ADDRESS_BOOK), map(function (action) { return action.payload; }), switchMap(function (payload) {
            var request = _this.normalizeRequestToMatchBackendStructure(payload);
            return _this.addressBookService.getContacts(request).pipe(switchMap(function (response) {
                return [new GetAddressBookSuccessAction(response)];
            }), catchError(function (error) { return of(new GetAddressBookFailureAction(error)); }));
        }));
        this.setAddressBookParams$ = this.actions$.pipe(ofType(SET_ADDRESS_BOOK_PARAMS), map(function (action) { return action.payload; }), map(function (payload) { return new GetAddressBookAction(payload); }));
    }
    AddressBookEffects.prototype.normalizeRequestToMatchBackendStructure = function (payload) {
        // backend's paginator starts from 1, but mat-paginator requires starting from 0,
        // so we need to increase current page number
        return __assign({}, payload, { pager: __assign({}, payload.pager, { page: payload.pager.page + 1 }) });
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AddressBookEffects.prototype, "getContacts$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AddressBookEffects.prototype, "setAddressBookParams$", void 0);
    return AddressBookEffects;
}());
export { AddressBookEffects };
